import React from "react";
import "./index.css";
import instagram from "../../icons/instagram.svg";
import facebook from "../../icons/facebook.svg";
import twitter from "../../icons/twitter.svg";

type ImageComponentT = 'img' | ((props: any) => JSX.Element | null);

export const Footer = ({ ImageComponent = 'img' } : { ImageComponent?: ImageComponentT }) => {
  return (
    <div className="footer">
      <div className="footer-columns">
        <div className="footer-column">
          <h4>CONNECT WITH US</h4>
          <div className="my-4 flex">
            <Socials ImageComponent={ImageComponent} />
          </div>
        </div>
        <div className="footer-column">
          <h4>THE COMPANY</h4>
          <ul>
            <li>
              <a href="https://account.antidotenepal.com/about-us">About Us</a>
            </li>
            <li>
              <a href="https://blog.antidotenepal.com">Blog</a>
            </li>
            {/* <li>
              <a href="">Careers</a>
            </li> */}
            <li>
              <a href="https://blog.antidotenepal.com/faqs">FAQs</a>
            </li>
            {/* <li>
              <a href="">Return Policy</a>
            </li> */}
          </ul>
        </div>
        <div className="footer-column">
          <h4>SHOP CATEGORIES</h4>
          <ul>
            <li>
              <a href="https://shop.antidotenepal.com/shop?filters=%7B%22categoryIds%22%3A%5B%226451563311a8c845ba9a6faa%22%5D%7D">
                Shoes
              </a>
            </li>
            <li>
              <a href="https://shop.antidotenepal.com/shop?filters=%7B%22categoryIds%22%3A%5B%226451563311a8c845ba9a700d%22%5D%7D">
                Dresses
              </a>
            </li>
            <li>
              <a href="https://shop.antidotenepal.com/shop?filters=%7B%22categoryIds%22%3A%5B%226451563311a8c845ba9a702f%22%5D%7D">
                Accessories
              </a>
            </li>
            {/* <li>
              <a href="">Books</a>
            </li> */}
            <li>
              <a href="https://shop.antidotenepal.com/shop?filters=%7B%22categoryIds%22%3A%5B%226451563311a8c845ba9a7022%22%5D%7D">
                Bags
              </a>
            </li>
            <li>
              <a href="https://shop.antidotenepal.com/shop?filters=%7B%22categoryIds%22%3A%5B%226451563311a8c845ba9a6fba%22%5D%7D">
                Pants & Jumpsuits
              </a>
            </li>
            <li>
              <a href="https://shop.antidotenepal.com/shop?filters=%7B%22categoryIds%22%3A%5B%226451563311a8c845ba9a6f45%22%5D%7D">
                Tops
              </a>
            </li>
            <li>
              <a href="https://shop.antidotenepal.com/shop?filters=%7B%22categoryIds%22%3A%5B%226451563311a8c845ba9a6f96%22%5D%7D">
                Beauty & Personal Care
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>SELL WITH US</h4>
          <ul>
            <li>
              <a href="https://sell.antidotenepal.com/#commission-and-fees">
                Commission and Fees
              </a>
            </li>
            <li>
              <a href="https://sell.antidotenepal.com/#how-it-works">
                How Does It Work?
              </a>
            </li>
            {/* <li>
              <a href="">How To Send?</a>
            </li> */}
          </ul>
        </div>
      </div>
      <hr />
      <div className="footer-copyright">
        <div className="footer-copyright-links">
          <a href="https://account.antidotenepal.com/terms-and-conditions">Terms Of Use</a>
          <a href="https://account.antidotenepal.com/terms-and-conditions">Privacy Policy</a>
        </div>
        <h4 className="my-4 text-center font-medium text-xs">
          © Antidote Apparel Pvt. Ltd. All Rights Reserved
        </h4>
      </div>
    </div>
  );
};

const SocialIcon = ({ src, alt, ImageComponent}: { src: string; alt: string, ImageComponent: ImageComponentT}) => (
  <div className="social-icon">
    <ImageComponent src={src} height={24} width={24} alt={alt} />
  </div>
);

function Socials({ ImageComponent } : { ImageComponent: ImageComponentT }) {
  return (
    <div className="socials">
      <a href="https://www.facebook.com/antidotego.shop" target="_blank">
        <SocialIcon ImageComponent={ImageComponent} src={facebook} alt="facebook" />
      </a>
      <a href="https://www.instagram.com/antidotenp/" target="_blank">
        <SocialIcon ImageComponent={ImageComponent} src={instagram} alt="instagram" />
      </a>
      <a href="https://twitter.com/antidote_np" target="_blank">
        <SocialIcon ImageComponent={ImageComponent} src={twitter} alt="twitter" />
      </a>
    </div>
  );
}
